<!-- 项目子项设置项 -->
<template lang="pug">
div
  el-form-item(label="多选" )
    el-switch(v-model="multiple2")
  el-form-item(label="关联更新" )
  field-setting(v-bind="$props", v-model="childNameKey", :label="`- ${$titles.child}名称`")
</template>

<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { CHILD_TYPE } from "./index";

export default {
  mixins: [settingMixin],
  props: {},
  data() {
    return {
      list: [
        {
          label: CHILD_TYPE.USER.LABEL,
          value: CHILD_TYPE.USER.VALUE
        },
        {
          label: CHILD_TYPE.PRJ_ALL.LABEL,
          value: CHILD_TYPE.PRJ_ALL.VALUE
        }
      ]
    };
  },
  computed: {
    ...mapVFOptions("childNameKey", "multiple2")
  }
};
</script>
